/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimplePersonalisationFromJSON, ApiSimplePersonalisationToJSON, } from './ApiSimplePersonalisation';
export function ApiReadPersonalisationResponseFromJSON(json) {
    return ApiReadPersonalisationResponseFromJSONTyped(json, false);
}
export function ApiReadPersonalisationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'personalisation': !exists(json, 'personalisation') ? undefined : ApiSimplePersonalisationFromJSON(json['personalisation']),
    };
}
export function ApiReadPersonalisationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'personalisation': ApiSimplePersonalisationToJSON(value.personalisation),
    };
}
